import CategoriesImageBox from "./CategoriesImageBox";
import { useRouter } from "next/router";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { getCookieItem } from "@/utils/utils";
const CategoriesComponent = ({ data }) => {
  const imageBoxesData = data.boxesData;
  const boxHeight = data.boxHeight;
  const boxWidth = data.boxWidth;
  const router = useRouter();

  const onClickCategory = (categoryid) => {
    const languageName = getCookieItem("language_name");
    const locationName = getCookieItem("location_name");
    const routePath = `/${languageName}/${locationName}/category/${categoryid}`;
    router.push(routePath);
  };

  const onClickViewAll = () => {
    const languageName = getCookieItem("language_name");
    const locationName = getCookieItem("location_name");
    const routePath = `/${languageName}/${locationName}/category`;
    router.push(routePath);
  };
  return (
    <div className="flex flex-col text-Default gap-4 md:gap-6 lg:gap-8 bg-CategoryBackgroundcolor pt-4 md:pt-8 lg:pt-12 md:pb-16 px-6 xs:px-8 sm:px-12 md:px-16 lg:px-20 xl:px-35">
      <div className="flex flex-row justify-between items-start">
        <h3 className="flex flex-row justify-start items-start gap-4 text-md md:text-lg lg:text-2xl xl:text-[34px] 2xl:text-4xl font-bastoni tracking-wide">
          {data.title}
          <div className="flex align-top lg:my-1 items-center relative w-5 h-5 md:w-7 md:h-7 lg:w-8 lg:h-8 xl:w-10 xl:h-10">
            <ImageWrapper
              src={data.titleImage}
              alt="Title Image"
              layout="fill"
              className="w-full h-full object-cover rounded-2xl"
            />
          </div>
        </h3>
        <button
          type="button"
          className="flex md:hidden text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          more
        </button>
        <button
          type="button"
          className="hidden md:flex text-sm cursor-pointer"
          onClick={onClickViewAll}
        >
          View all
        </button>
      </div>

      <div className=" flex overflow-x-auto gap-4 scrollbar-hide pb-5 ">
        {imageBoxesData &&
          imageBoxesData.map((boxData, index) => (
            <CategoriesImageBox
              key={`boxData-${index}`}
              name={boxData.subCategoryName}
              imageUrl={boxData.imageLink}
              altText={boxData.subCategoryName}
              boxHeight={boxHeight}
              boxWidth={boxWidth}
              onClick={onClickCategory}
              categoryid={boxData.slug}
            />
          ))}
      </div>
    </div>
  );
};

export default CategoriesComponent;
